// extracted by mini-css-extract-plugin
module.exports = {"root":"hero-module--root--1ID8S","fadeOut":"hero-module--fadeOut--2KBys"};